import { all, call, put, takeLatest } from "redux-saga/effects";
import { request, httpService } from "@app/services";

import * as endpoints from "./endpoints";
import {
  login,
  loginSuccess,
  loginFailed,
  signUp,
  signUpSuccess,
  signUpFailed,
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordFailed,
  resetPassword,
  resetPasswordSuccess,
  resetPasswordFailed,
} from "./slice";
import { IRequestFailed } from "./types";

import { prepareUserSessionSaga } from "../bootstrap";
import { setLogin, setRole } from "../common";

//---------------------SignInSaga-----------------------

function* loginSaga(action: ReturnType<typeof login>): any {
  try {
    const { email, password } = action.payload;
    const { data, token } = yield call(request.post, endpoints.login, {
      email,
      password,
    });
    httpService.setToken(token);
    yield put(setRole(data?.role?.role));
    yield put(loginSuccess(data));
    yield put(setLogin({ ...data, token }));
    yield call(prepareUserSessionSaga);
  } catch (error) {
    yield put(loginFailed(error as IRequestFailed));
  }
}
//--------------------SignUpSaga-------------------------

function* signUpSaga(action: ReturnType<typeof signUp>): any {
  try {
    const { firstName, lastName, email, password, userType } = action.payload;
    const { data } = yield call(request.post, endpoints.signUp, {
      firstName,
      lastName,
      email,
      password,
      userType,
    });
    yield put(signUpSuccess(data));
  } catch (error: any) {
    yield put(signUpFailed(error));
  }
}

function* forgotPasswordSaga(action: ReturnType<typeof forgotPassword>): any {
  try {
    const { email } = action.payload;
    const { data } = yield call(request.post, endpoints.forgotPassword, {
      email,
    });
    yield put(forgotPasswordSuccess(data));
  } catch (error: any) {
    yield put(forgotPasswordFailed(error));
  }
}

function* resetPasswordSaga(action: ReturnType<typeof resetPassword>): any {
  try {
    const { password, token } = action.payload;
    const { data } = yield call(
      request.put,
      endpoints.resetPassword,
      {
        password,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(resetPasswordSuccess(data));
  } catch (error: any) {
    yield put(resetPasswordFailed(error));
  }
}

function* authSagas() {
  yield all([
    takeLatest(login, loginSaga),
    takeLatest(signUp, signUpSaga),
    takeLatest(forgotPassword, forgotPasswordSaga),
    takeLatest(resetPassword, resetPasswordSaga),
  ]);
}

export { authSagas };
